import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';
import { BillingBanner } from '@/features/billing/billing-banner';

export function AppShell() {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  // Fecha o drawer ao mudar de rota
  React.useEffect(() => {
    const onClick = () => setMobileOpen(false);
    window.addEventListener('popstate', onClick);
    return () => window.removeEventListener('popstate', onClick);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-background text-foreground">
      {/* Sidebar fixa em >=lg */}
      <div className="hidden w-64 shrink-0 lg:block" data-print-hide>
        <Sidebar />
      </div>

      {/* Drawer mobile */}
      {mobileOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/40 lg:hidden"
            onClick={() => setMobileOpen(false)}
            aria-hidden="true"
          />
          <div className="fixed inset-y-0 left-0 z-50 w-72 animate-in slide-in-from-left duration-200 lg:hidden">
            <Sidebar onNavigate={() => setMobileOpen(false)} />
          </div>
        </>
      )}

      <div className="flex flex-1 flex-col overflow-hidden">
        <div data-print-hide>
          <Topbar onOpenSidebar={() => setMobileOpen(true)} />
          <BillingBanner />
        </div>
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
